import { deleteField } from 'firebase/firestore';

// =====================================================================
// 🎫 Visitas del período con pago adelantado.
// Antes, cualquier cobro reseteaba las visitas a 0 en el momento — si el
// socio pagaba el mes siguiente antes de que se le venciera el actual
// (ej: usó 3 de 4 y paga el día 20 con vencimiento el 25), recuperaba el
// cupo completo en el mes que todavía estaba corriendo.
// Ahora un cobro adelantado deja guardado `proximoReinicioVisitas` (la
// fecha en que empieza el mes que pagó) y las visitas se reinician recién
// ese día. Si pagó varios meses, el reinicio avanza mes a mes hasta su
// renewalDate; el último reinicio lo hace el próximo cobro, como siempre.
// =====================================================================

const hoyStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

// Mismo cálculo que addOneMonth de MembershipsManagement: un mes después,
// conservando el día fijo de cobro (con tope en el último día del mes).
export const sumarMesCobro = (dateStr, dia) => {
  const [y, m, d] = dateStr.split('-').map(Number);
  const diaFijo = Number(dia) || d;
  const ultimoDia = new Date(y, m + 1, 0).getDate();
  const next = new Date(y, m, Math.min(diaFijo, ultimoDia));
  return `${next.getFullYear()}-${String(next.getMonth() + 1).padStart(2, '0')}-${String(next.getDate()).padStart(2, '0')}`;
};

// Devuelve el socio con las visitas que valen HOY: si ya llegó la fecha de
// un reinicio pendiente, las visitas del período nuevo arrancan en 0
// (aunque en Firestore todavía figuren las del mes anterior).
export const visitasDelPeriodo = (member, hoy = hoyStr()) => {
  const r = member?.proximoReinicioVisitas;
  if (r && r <= hoy) return { ...member, visitsUsedThisPeriod: 0, bonusVisitsUsedThisPeriod: 0 };
  return member;
};

// Campos para escribir junto con una visita nueva: si el reinicio pendiente
// ya llegó, pone los contadores en 0 (la visita se suma encima) y deja
// programado el siguiente reinicio, o lo borra si ya no quedan meses pagos.
export const camposReinicioVisitas = (member, hoy = hoyStr()) => {
  const r = member?.proximoReinicioVisitas;
  if (!r || r > hoy) return {};
  let next = r;
  while (next <= hoy) next = sumarMesCobro(next, member.billingDay);
  return {
    visitsUsedThisPeriod: 0,
    bonusVisitsUsedThisPeriod: 0,
    proximoReinicioVisitas: member.renewalDate && next < member.renewalDate ? next : deleteField(),
  };
};
